import emoji from 'node-emoji';
import React, { useCallback, useEffect, useLayoutEffect, useRef, useState, } from 'react';
import { Alert, TextInput, View } from 'react-native';
import { AppView, rem } from 'design-system';
import useColors from 'hooks/useColors';
import { getEnergySwitchingResults } from 'actions';
import { muteErrorAndResult, useFetchOld } from 'hooks';
import Amplitude from 'utils/amplitude';
import { useAutoFocusInput } from 'hooks/useAutoFocusInput';
import createStyleSheets from 'utils/createStyleSheets';
import useStyles from 'hooks/useStyles';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
import StatusBar from 'design-system/StatusBar';
import { validateUKPostcode } from 'utils/validation';
import { KeyboardAvoidingContainerNew } from 'design-system/KeyboardAvoidingContainerNew';
import { KeyboardAvoidingButton } from 'design-system/KeyboardAvoidingButton';
import { useAppSelector } from 'store/hooks';
import { selectPrimaryAddress } from 'reducers/selectors';
import { isWeb } from '../../../../../constants';
const PostCode = ({ navigation, route }) => {
    const colors = useColors();
    useLayoutEffect(() => {
        navigation.setOptions({
            title: 'What is your postcode?',
            headerTintColor: colors.text.primary,
        });
    }, [colors.text.primary]);
    const primaryAddress = useAppSelector(selectPrimaryAddress);
    const [value, setValue] = useState(() => primaryAddress?.postcode || '');
    useEffect(() => {
        Amplitude.logEvent('Broadband.Postcode');
    }, []);
    const [, , isFetching, fetch] = useFetchOld(muteErrorAndResult);
    const onPressNext = useCallback(async () => {
        const { params } = route;
        const postcode = value.trim();
        const postcodes = validateUKPostcode(postcode);
        if (!postcode || !postcodes) {
            return Alert.alert(emoji.emojify('Hold on :dizzy:'), 'You need to enter a valid postcode.');
        }
        const secondBody = {
            action: 'QUICK_SEARCH',
            data: {
                postcode,
            },
        };
        const { data } = params;
        const { enquiryId } = data;
        const secondResponse = await fetch(getEnergySwitchingResults(String(enquiryId), secondBody));
        if (!secondResponse)
            return false;
        const keyBack = params && params.keyBack ? params.keyBack : route.key;
        navigation.replace('BroadBandQuotes', {
            ...params,
            data: secondResponse.payload,
            keyBack,
            enquiryId,
        });
        return true;
    }, [route, value]);
    const { width } = useAppFrameDimensions(isWeb);
    const textInputRef = useRef(null);
    useAutoFocusInput(textInputRef);
    const styles = useStyles(styleSet);
    const onSetPostCode = useCallback((postcode) => {
        setValue(postcode.toUpperCase());
    }, []);
    const input = (<TextInput ref={textInputRef} style={[styles.textinput, { width: width - 40 }]} placeholder="e.g. N193PH" placeholderTextColor={colors.text.placeholder} selectionColor={colors.text.selection} allowFontScaling={false} underlineColorAndroid="transparent" onChangeText={onSetPostCode} onSubmitEditing={onPressNext} value={value} maxLength={12} autoCapitalize="characters" testID="textInput"/>);
    return (<AppView type="primary" avoidHeader>
      <StatusBar barStyle="dark-content" animated/>
      <KeyboardAvoidingContainerNew flexContainer withButtonSpace>
        <View style={styles.container}>{input}</View>
      </KeyboardAvoidingContainerNew>
      <KeyboardAvoidingButton brand title="Next" isFetching={isFetching} onPress={onPressNext} withFrame={false}/>
    </AppView>);
};
const styleSet = createStyleSheets((colors) => ({
    container: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
    },
    textinput: {
        fontFamily: 'Montserrat-Light',
        fontSize: rem(24),
        textAlign: 'center',
        color: colors.text.primary,
    },
}));
export default PostCode;
